module.exports = __webpack_public_path__ + "static/02-21db74a33cc152392ac3ff67d20576bb.jpg";